import { gql } from '@apollo/client'

import {
  AiOfferLock,
  AiTwoOffersLock,
  CaseTrackingBgCheckFromBgCheckOffersLock,
  CaseTrackingBGCheckFromLawsuitOffersLock,
  CustomPlanLock,
  DoctrineOneOfferLock,
  DoctrineUnloggedLock,
  DynamicMultipleOffersChooseFrequencyLaterLock,
  DynamicMultipleOffersSwitchFrequencyLock,
  DynamicMultipleOffersSwitchFrequencyNewBenefitsLock,
  InconsistentPlanLock,
  JurisThreeOffersSwitchFrequencyLock,
  LawsuitNameMonitoringLock,
  LawsuitTwoOffersLock,
  LimitOverflowLock,
  LinkedAccountLock,
  OneOfferLock,
  PayPerViewLock,
  PixUpgradeLock,
  ThirdPartyBackgroundCheckLock,
  TwoOffersLock,
  TwoOffersSwitchFrequencyLock,
  UpdatePaymentInfoLock,
  UpgradePlanLock,
} from './components'
import { useSendViewItemEvent } from './hooks/use-send-view-item-event'

export const BoxLockQuery = gql`
  query BoxLockQuery(
    $appId: String
    $adminOptions: AdminOptionsInput = {}
    $featureCode: String!
    $fromComponent: String
    $boxOptions: BoxOptionsInput
    $pageMetadata: PageMetadataInput
  ) {
    root {
      boxLockViewer(
        appId: $appId
        adminOptions: $adminOptions
        featureCode: $featureCode
        fromComponent: $fromComponent
        boxOptions: $boxOptions
        pageMetadata: $pageMetadata
      ) {
        lockVariationType
        metadataToDebug
        offerLockData {
          body {
            cards {
              lockEventProperties {
                pid
                feature
                current_plan
                next_plan
                plan_price
                modal_type
                experiment_id
                app_id
                resource_id
                parent_resource_id
                from_component
              }
            }

            ...UseSendViewItemEvent_offerLockBody
          }

          ...InconsistentPlanLock_offerLockData
          ...LimitOverflowLock_offerLockData
          ...UpdatePaymentInfoLock_offerLockData
          ...LinkedAccountLock_offerLockData
          ...TwoOffersLock_offerLockData
          ...TwoOffersSwitchFrequencyLock_offerLockData
          ...OneOfferLock_offerLockData
          ...UpgradePlanLock_offerLockData
          ...DoctrineOneOfferLock_offerLockData
          ...DoctrineUnloggedLock_offerLockData
          ...AiOfferLock_offerLockData
          ...LawsuitTwoOffersLock_offerLockData
          ...LawsuitNameMonitoringLock_offerLockData
          ...AiTwoOffersLock_offerLockData
          ...PayPerViewLock_offerLockData
          ...ThirdPartyBackgroundCheckLock_offerLockData
          ...PixUpgradeLock_offerLockData
          ...CustomPlanLock_offerLockData
          ...JurisThreeOffersSwitchFrequencyLock_offerLockData
          ...CaseTrackingBgCheckFromBgCheckOffersLock_offerLockData
          ...CaseTrackingBGCheckFromLawsuitOffersLock_offerLockData
          ...DynamicMultipleOffersSwitchFrequencyLock_offerLockData
          ...DynamicMultipleOffersSwitchFrequencyNewBenefitsLock_offerLockData
          ...DynamicMultipleOffersChooseFrequencyLaterLock_offerLockData
        }
      }

      viewer: me {
        ...TwoOffersLock_viewer
        ...TwoOffersSwitchFrequencyLock_viewer
        ...OneOfferLock_viewer
        ...UpgradePlanLock_viewer
        ...DoctrineOneOfferLock_viewer
        ...AiOfferLock_viewer
        ...LawsuitTwoOffersLock_viewer
        ...LawsuitNameMonitoringLock_viewer
        ...AiTwoOffersLock_viewer
        ...PayPerViewLock_viewer
        ...ThirdPartyBackgroundCheckLock_viewer
        ...CustomPlanLock_viewer
        ...JurisThreeOffersSwitchFrequencyLock_viewer
        ...CaseTrackingBgCheckFromBgCheckOffersLock_viewer
        ...CaseTrackingBGCheckFromLawsuitOffersLock_viewer
        ...DynamicMultipleOffersSwitchFrequencyLock_viewer
        ...DynamicMultipleOffersSwitchFrequencyNewBenefitsLock_viewer
        ...DynamicMultipleOffersChooseFrequencyLaterLock_viewer
      }
    }
  }
  ${useSendViewItemEvent.fragments.offerLockBody}
  ${InconsistentPlanLock.fragments.offerLockData}
  ${LimitOverflowLock.fragments.offerLockData}
  ${UpdatePaymentInfoLock.fragments.offerLockData}
  ${LinkedAccountLock.fragments.offerLockData}
  ${TwoOffersLock.fragments.offerLockData}
  ${TwoOffersLock.fragments.viewer}
  ${TwoOffersSwitchFrequencyLock.fragments.offerLockData}
  ${TwoOffersSwitchFrequencyLock.fragments.viewer}
  ${OneOfferLock.fragments.offerLockData}
  ${OneOfferLock.fragments.viewer}
  ${UpgradePlanLock.fragments.offerLockData}
  ${UpgradePlanLock.fragments.viewer}
  ${DoctrineOneOfferLock.fragments.offerLockData}
  ${DoctrineOneOfferLock.fragments.viewer}
  ${DoctrineUnloggedLock.fragments.offerLockData}
  ${AiOfferLock.fragments.offerLockData}
  ${AiOfferLock.fragments.viewer}
  ${LawsuitTwoOffersLock.fragments.offerLockData}
  ${LawsuitTwoOffersLock.fragments.viewer}
  ${LawsuitNameMonitoringLock.fragments.offerLockData}
  ${LawsuitNameMonitoringLock.fragments.viewer}
  ${AiTwoOffersLock.fragments.offerLockData}
  ${AiTwoOffersLock.fragments.viewer}
  ${PayPerViewLock.fragments.offerLockData}
  ${PayPerViewLock.fragments.viewer}
  ${ThirdPartyBackgroundCheckLock.fragments.offerLockData}
  ${ThirdPartyBackgroundCheckLock.fragments.viewer}
  ${PixUpgradeLock.fragments.offerLockData}
  ${CustomPlanLock.fragments.offerLockData}
  ${CustomPlanLock.fragments.viewer}
  ${JurisThreeOffersSwitchFrequencyLock.fragments.offerLockData}
  ${JurisThreeOffersSwitchFrequencyLock.fragments.viewer}
  ${CaseTrackingBgCheckFromBgCheckOffersLock.fragments.offerLockData}
  ${CaseTrackingBgCheckFromBgCheckOffersLock.fragments.viewer}
  ${CaseTrackingBGCheckFromLawsuitOffersLock.fragments.offerLockData}
  ${CaseTrackingBGCheckFromLawsuitOffersLock.fragments.viewer}
  ${DynamicMultipleOffersSwitchFrequencyLock.fragments.offerLockData}
  ${DynamicMultipleOffersSwitchFrequencyLock.fragments.viewer}
  ${DynamicMultipleOffersSwitchFrequencyNewBenefitsLock.fragments.offerLockData}
  ${DynamicMultipleOffersSwitchFrequencyNewBenefitsLock.fragments.viewer}
  ${DynamicMultipleOffersChooseFrequencyLaterLock.fragments.offerLockData}
  ${DynamicMultipleOffersChooseFrequencyLaterLock.fragments.viewer}
`
